<script setup>
import { onMounted, onBeforeUnmount, watch, ref } from 'vue'

const emit = defineEmits(['monitorBuffering'])

// Props: Accept a ref to the video element
const props = defineProps({
  videoElement: {
    type: Object, // this will be a Ref<HTMLVideoElement | null>
    required: true
  },
  trialTodayTime: { type: Number, default: undefined },
})

let bufferingTimeout = null
let playStartedAtS = null
const isBuffering = { value: false, startReporting: false }

// Store handler references
const onPlay = () => {
  //console.log("onPlay event")
  videoStarts()
}
const onWaiting = () => {
  //console.log("onWaiting event")
  bufferingStarts()
}
const onPlaying = () => {
  if (!isBuffering.startReporting && playStartedAtS === null) playStartedAtS = Date.now() / 1000
  isBuffering.startReporting = true
  videoStarts()
}
const onStalled = () => {
  //console.log("onStalled event")
  //bufferingStarts()
}

function addEventListeners(video) {
  //console.log("addEventListeners")
  //console.dir(video)
  video.addEventListener('play', onPlay)
  video.addEventListener('waiting', onWaiting)
  video.addEventListener('playing', onPlaying)
  video.addEventListener('stalled', onStalled)
}

function removeEventListeners(video) {
  video.removeEventListener('play', onPlay)
  video.removeEventListener('waiting', onWaiting)
  video.removeEventListener('playing', onPlaying)
  video.removeEventListener('stalled', onStalled)
}

function bufferingStarts() {
  if (!isBuffering.startReporting) return
  if (isBuffering.value) return
  isBuffering.value = true

  if (props.trialTodayTime !== undefined) {
    const sessionTime = Date.now() / 1000 - playStartedAtS
    if (sessionTime > props.trialTodayTime) {
      isBuffering.value = false
      return
    }
  }

  bufferingTimeout = setTimeout(() => {
    if (isBuffering.value) {
      //console.log('[Monitor] Buffering > 1s. Sending request to backend...')
      emit('monitorBuffering')
    }
  }, 1000)
}

function videoStarts() {
  if (!isBuffering.value) return
  //console.log(`[Monitor] Buffering ended.`)

  isBuffering.value = false
  clearTimeout(bufferingTimeout)
}

onMounted(() => {
  //console.log("onMounted")

  watch(
      () => props.videoElement,
      (video, _prev, onCleanup) => {
        if (!video) return;
        addEventListeners(video);
        onCleanup(() => {
          isBuffering.startReporting = false;
          removeEventListeners(video);
        });
      },
      { immediate: true }
  );
})

onBeforeUnmount(() => {
  if (bufferingTimeout) {
    clearTimeout(bufferingTimeout)
    bufferingTimeout = null
  }
  isBuffering.value = false
  isBuffering.startReporting = false
  const video = props.videoElement
  if (video) {
    removeEventListeners(video)
  }
})
</script>

<template>
  <div style="display: none" />
</template>
